import React, { useRef } from 'react';
import get from 'lodash/get';
import { Field } from 'react-final-form';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
const fileDownload = require('js-file-download');

import { axiosApi, handleAxiosResponse } from '../../util/axiosApi';
import { limitText } from '../LatestNewsSection/utils';

import ImagePreview from '../ImagePreview/ImagePreview';
import PdfPreview from '../PdfPreview/PdfPreview';

import css from './FileUploadField.module.css';

const FileUploadField = ({ name, id, addNewEmpty, remove, usePreviewIcon }) => {
  const fileInputRef = useRef(null);

  const uploadField = ({ input: { onChange, value }, label, ...rest }) => {
    const onFileChange = event => {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append(file.path, file);
      return axiosApi.post('/aws/upload', formData, {
        withCredentials: true,
      })
        .then(handleAxiosResponse)
        .then(files => {
          const file = get(files, '[0]', null);
          onChange(file);
          addNewEmpty();
        })
        .catch(error => {
          console.log(error);
        });
    };

    if (value) {
      const fileName = value.name;

      const handleDownloadFile = () => {
        axiosApi.get(`/aws/download?key=${value.key}`, {
          responseType: 'blob',
        })
          .then(resp => {
            fileDownload(resp.data, value.name);
          })
          .catch(() => {})
        ;
      };

      const handleDeleteFile = e => {
        e.stopPropagation();
        e.preventDefault();
        return axiosApi.delete(`/aws/${value.key}`, {
          withCredentials: true,
        })
          .then(() => remove())
          .catch(() => {});
      };

      let content;
      if (value?.type?.includes('image')) {
        content = (
          <ImagePreview
            file={value}
          />
        );
      } else if (value?.type?.includes('pdf')) {
        content = (
          <PdfPreview
            file={value}
            onClick={handleDownloadFile}
            usePreviewIcon={usePreviewIcon}
          />
        );
      } else {
        content = (
          <div className={css.folderIcon}>
            <FolderIcon className={css.icon} />
            {/* {limitText(fileName, 15)} */}
          </div>
        );
      }

      return (
        <div className={css.fileIcon} title="download" onClick={handleDownloadFile}>
          <DeleteIcon className={css.deleteIcon} onClick={handleDeleteFile} />
          {content}
        </div>
      );
    }

    return (
      <div className={css.wrapper}>
        <input
          type="file"
          className={css.hiddenFileInput}
          onChange={onFileChange}
          ref={fileInputRef}
        />

        <div className={css.addFileButton} onClick={() => fileInputRef.current.click()}>
          Add
          <DriveFolderUploadIcon id="upload-icon" fontSize="large" className={css.addFileIcon} />
        </div>
      </div>
    );
  };

  return <Field id={id} name={name} component={uploadField} />;
};

export default FileUploadField;
